/* eslint-disable camelcase */
import React from 'react';
import {
  Avatar,
  Box,
  Stack,
  Typography,
} from '@mui/material';
import {
  ProtegeIcon, BackrIcon, AdminRoleIcon, RoundEditIcon,
} from 'pages/wholeme/icons/Icons';
import {
  childrenContainerStyle,
  avatarStyle,
  profileContainerStyle,
  BPIconStyle,
  imageContainerStyle,
  AdminIconStyle,
} from './WholeMeAvatarStyles';
import ActionsGrid from '../../../../common/atoms/actionsGrid/ActionsGrid';
import ProfileOptionsMenu from '../profileOptionsMenu/ProfileOptionsMenu';
import { useAuthContext } from '../../../../providers/auth-provider';

const STUDENT_ROLES = ['Student', 'Scholar', 'Foundations'];
const PROFESSIONAL_ROLES = ['Professional'];
const ADMIN_ROLES = ['Admin User'];

const RenderIcon = ({ roles = [], legacyRole, editMeta }) => {
  if (editMeta?.onEdit) {
    return (
      <Box sx={{ cursor: 'pointer' }} onClick={() => editMeta?.setIsEditMode(true)}>
        <RoundEditIcon {...BPIconStyle} />
      </Box>
    );
  }
  if (legacyRole === 'admin' || ADMIN_ROLES.some((role) => roles.some((userRole) => userRole?.name === role))) {
    return <AdminRoleIcon {...AdminIconStyle} />;
  }
  if (STUDENT_ROLES.some((role) => roles.some((userRole) => userRole?.name === role))) {
    return <ProtegeIcon {...BPIconStyle} />;
  }
  if (PROFESSIONAL_ROLES.some((role) => roles.some((userRole) => userRole?.name === role))) {
    return <BackrIcon {...BPIconStyle} />;
  }
  return null;
};

const WholeMeProfileAvatar = ({
  profile,
  permissions,
  editMeta,
  refreshProfile,
  userPermissions,
}) => {
  const {
    last_name: lastName,
    first_name: firstName,
    profile_image: profileImage,
    role: subjectRole,
    roles: subjectRoles,
  } = profile;
  const { user } = useAuthContext();
  const subjectIsAdmin = subjectRole === 'admin';
  const subjectIsSelf = user?.id === profile?.id;
  const showProfileOptionsMenu = !subjectIsSelf;
  const defaultProfileImage = '/assets/profile/default-profile-image.svg';
  const showFullName = permissions?.view_full_name?.allowed;

  const RenderName = () => {
    if (subjectIsAdmin || showFullName) { return `${firstName} ${lastName}`; }
    if (firstName && lastName) {
      return `${firstName} ${lastName.charAt(0)}.`;
    }
    return 'Me';
  };

  const nameStyle = {
    color: '#03295F',
    fontSize: '1.3rem',
    fontWeight: 700,
    paddingRight: showProfileOptionsMenu && '1rem',
  };

  return (
    <Stack sx={profileContainerStyle}>
      <Box sx={{ ...imageContainerStyle, ...childrenContainerStyle }}>
        <Box style={{ position: 'relative' }}>
          {subjectIsAdmin
            ? (
              <object
                type="image/svg+xml"
                data={profileImage}
                style={avatarStyle}
              >
                <img src={profileImage} alt="coach lubav hat" />
              </object>
            ) : (
              <Avatar aria-label="profile picture" src={profileImage} sx={avatarStyle}>
                <img style={avatarStyle} src={defaultProfileImage} alt="profile" />
              </Avatar>
            )}
          <RenderIcon roles={subjectRoles} legacyRole={subjectRole} editMeta={editMeta} />
        </Box>
        <Box style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <Box>
            <Typography style={nameStyle}>
              {RenderName()}
            </Typography>
            {showProfileOptionsMenu && <ProfileOptionsMenu profile={profile} />}
          </Box>
          <ActionsGrid
            profile={profile}
            permissions={permissions}
            refreshProfile={refreshProfile}
            userPermissions={userPermissions}
          />
        </Box>
      </Box>
    </Stack>
  );
};

export default WholeMeProfileAvatar;
